// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"toolbar__Uzo9W","logo":"logo__2kwkS","customlogo":"customlogo__1YTww","customFooterLogo":"customFooterLogo__1xkxs"};


//////////////////
// WEBPACK FOOTER
// ./components/header/style.scss
// module id = /Umn
// module chunks = 1